import { toast } from "vue3-toastify";

const defaultOption = {
    autoClose: 4000,
    hideProgressBar: true,
    position: toast.POSITION.BOTTOM_RIGHT,
};

export function success(message) {
    toast(message, {
        ...defaultOption,
        type: "success",
    });
}

export function warning(message) {
    toast(message, {
        ...defaultOption,
        type: "warning",
    });
}

export function error(message) {
    toast(message, {
        ...defaultOption,
        type: "error",
    });
}

export function info(message) {
    toast(message, {
        ...defaultOption,
        type: "info",
    });
}